const CUENTAS_ORDEN = '0'
const ACTIVO_DISPONIBLE_EXIGIBLE = '1'
const ACTIVO_REALIZABLE = '2'
const ACTIVO_INMOVILIZADO = '3'
const PASIVO = '4'
const PATRIMONIO_NETO = '5'
const GASTOS_POR_NATURALEZA = '6'
const INGRESOS_POR_NATURALEZA = '7'
const SALDOS_INTERMEDIOS_DE_GESTION = '8'
const COSTOS_ANALITICOS = '9'

const __dictionary = {
  [CUENTAS_ORDEN]: {
    id: CUENTAS_ORDEN,
    nombre: 'CUENTAS DE ORDEN'
  },
  [ACTIVO_DISPONIBLE_EXIGIBLE]: {
    id: ACTIVO_DISPONIBLE_EXIGIBLE,
    nombre: 'ACTIVO DISPONIBLE Y FLEXIBLE'
  },
  [ACTIVO_REALIZABLE]: {
    id: ACTIVO_REALIZABLE,
    nombre: 'ACTIVO REALIZABLE'
  },
  [ACTIVO_INMOVILIZADO]: {
    id: ACTIVO_INMOVILIZADO,
    nombre: 'ACTIVO INMOVILIZADO'
  },
  [PASIVO]: {
    id: PASIVO,
    nombre: 'PASIVO'
  },
  [PATRIMONIO_NETO]: {
    id: PATRIMONIO_NETO,
    nombre: 'PATRIMONIO NETO'
  },
  [GASTOS_POR_NATURALEZA]: {
    id: GASTOS_POR_NATURALEZA,
    nombre: 'GASTOS POR NATURALEZA'
  },
  [INGRESOS_POR_NATURALEZA]: {
    id: INGRESOS_POR_NATURALEZA,
    nombre: 'INGRESOS POR NATURALEZA'
  },
  [SALDOS_INTERMEDIOS_DE_GESTION]: {
    id: SALDOS_INTERMEDIOS_DE_GESTION,
    nombre: 'SALDOS INTERMEDIOS DE GESTION'
  },
  [COSTOS_ANALITICOS]: {
    id: COSTOS_ANALITICOS,
    nombre: 'COSTOS ANALITICOS'
  }
}

const __array = [
  __dictionary[CUENTAS_ORDEN],
  __dictionary[ACTIVO_DISPONIBLE_EXIGIBLE],
  __dictionary[ACTIVO_REALIZABLE],
  __dictionary[ACTIVO_INMOVILIZADO],
  __dictionary[PASIVO],
  __dictionary[PATRIMONIO_NETO],
  __dictionary[GASTOS_POR_NATURALEZA],
  __dictionary[INGRESOS_POR_NATURALEZA],
  __dictionary[SALDOS_INTERMEDIOS_DE_GESTION],
  __dictionary[COSTOS_ANALITICOS]
]

export default Object.freeze({
  CUENTAS_ORDEN,
  ACTIVO_DISPONIBLE_EXIGIBLE,
  ACTIVO_REALIZABLE,
  ACTIVO_INMOVILIZADO,
  PASIVO,
  PATRIMONIO_NETO,
  GASTOS_POR_NATURALEZA,
  INGRESOS_POR_NATURALEZA,
  SALDOS_INTERMEDIOS_DE_GESTION,
  COSTOS_ANALITICOS,
  __dictionary,
  __array
})
